<template>
  <div>
    <jump-header />
    <div class="topnews-wrapper">
      <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="没有更多了~"
        @load="onLoad"
      >
        <div
          class="topnews-item"
          v-for="item in topNewsList"
          :key="item.id"
          @click="toNewsDetail(item)"
        >
          <div class="item-left">
            <div class="item-left-title text-line-2">{{ item.name }}</div>
            <div class="item-left-bottom">
              <div class="item-tag">{{ item.newsTag }}</div>
              <span class="item-time">{{ item.effectDate }}</span>
            </div>
          </div>
          <div class="item-right">
            <img :src="item.pictureUrl" alt="" />
          </div>
        </div>
      </van-list>
    </div>
    <div class="top-icon" v-if="showToTopIcon" @click="scrollToTop">
      <van-icon name="back-top" color="#fff" size="22px" />
    </div>
  </div>
</template>

<script>
import wxSdk from "@/http/wxApi.js";
import { defineComponent, onMounted, ref } from "vue";
import JumpHeader from "@/components/Base/JumpHeader";
import { queryAllTopNewsListByPage } from "@/http/api";

export default defineComponent({
  name: "topNewsList",
  components: {
    JumpHeader,
  },
  setup() {
    const page = ref(1);
    const totalPage = ref(0);
    const loading = ref(false);
    const finished = ref(false);
    const topNewsList = ref([]);
    const showToTopIcon = ref(false);
    let timer = null;

    const onLoad = () => {
      page.value++;
      getTopNewsList();
    };

    const getTopNewsList = async () => {
      const { data } = await queryAllTopNewsListByPage({
        rows: 10,
        page: page.value,
      });
      loading.value = false;
      topNewsList.value = [...topNewsList.value, ...data.pageList];
      totalPage.value = data.totalPage;
      if (totalPage.value <= page.value) {
        finished.value = true;
      }
    };

    const scrollToTop = () => {
      let dom = document.querySelectorAll(".topnews-item")[0];
      dom.scrollIntoView({ behavior: "smooth", block: "center" });
    };

    const wxShare = () => {
      wxSdk.getJSSDK({
        title: "欢迎进入粤语音频第一入口，听最新资讯，花城FM就系甘啱听！",
        desc: "欢迎使用花城FM",
        linkurl: `https://app.gztv.com/hcfmshare/#/TopNewsList`,
        img: "https://app.gztv.com/filedata/defaultSharePic/topnews.png",
      });
    };

    const toNewsDetail = (item) => {
      window.location.href = item.htmlUrl;
    };

    onMounted(() => {
      wxShare();
      getTopNewsList();
      window.addEventListener("scroll", (e) => {
        if (timer) {
          return;
        }
        timer = setTimeout(() => {
          let scrollY =
            document.documentElement.scrollTop || document.body.scrollTop;
          if (scrollY > 1500) {
            showToTopIcon.value = true;
          } else {
            showToTopIcon.value = false;
          }
          timer = null;
        }, 300);
      });
    });

    return {
      page,
      onLoad,
      loading,
      finished,
      topNewsList,
      scrollToTop,
      toNewsDetail,
      showToTopIcon,
    };
  },
});
</script>

<style lang="scss" scoped>
.topnews-wrapper {
  max-width: 450px;
  margin: 60px auto 0;
}

.topnews-item {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 0 13px 10px;
  margin-top: 10px;
  border-bottom: 1px solid #f5f5f5;

  .item-left {
    display: flex;
    flex: 1;
    height: 100px;
    flex-direction: column;
    justify-content: space-between;
    margin-right: 10px;
    box-sizing: border-box;
    padding: 5px 0;

    .item-left-title {
      font-size: 18px;
      line-height: 24px;
      color: #111;
      font-weight: bold;
    }

    .item-left-bottom {
      display: flex;
      align-items: center;

      .item-tag {
        padding: 3px 5px;
        border-radius: 4px;
        font-size: 12px;
        color: #fff;
        background: rgba(231, 56, 40, 0.7);
      }

      .item-time {
        font-size: 12px;
        color: #999;
        margin-left: 10px;
      }
    }
  }

  .item-right {
    width: 100px;
    height: 100px;
    min-width: 100px;
    border-radius: 12px;

    & > img {
      width: 100%;
      height: 100%;
      border-radius: 12px;
    }
  }
}

.top-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 50px;
  right: 10%;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.6);
  background: rgba(0, 0, 0, 0.6);
}
</style>
